import { render, staticRenderFns } from "./wechat-settlement.vue?vue&type=template&id=e6d944cc&"
import script from "./wechat-settlement.vue?vue&type=script&lang=ts&"
export * from "./wechat-settlement.vue?vue&type=script&lang=ts&"
import style0 from "./wechat-settlement.vue?vue&type=style&index=0&id=e6d944cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports